import { Div, Image } from "@tblabs/truffle";
import { H2 } from "./H2";
import { Paragraph } from "./Paragraph";
import { ShopContentProvider } from "../../Services/Content/ShopContentProvider";


export class AboutUsSection extends Div
{
    constructor(private _shop: ShopContentProvider)
    {
        super("container");

        this.Append(
            new Div("about").Id("o-nas").Append(
                new H2("O nas").Class("section-title ml-60 text-slate-100 sr-only"),
                new Div("about__content").Append(
                    new Image(this._shop.Shop.Logo.value).Class("about__logo"),
                    new Paragraph(this._shop.Shop.AboutUsText.value).Class("about__text")
                )
            )
        );
    }
}